<template>
  <div id="edit-column-order">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center mb-base">
        <div class="flex-grow">
          <div class="upper-controller">
            <span class="title">表示順序変更</span>
            <vs-button
              class="order-cancel-button top-button"
              @click="cancelEditOrder"
              color="#BDBDBD"
            >
              <div class="button-inner">
                <span>キャンセル</span>
              </div>
            </vs-button>
            <vs-button
              class="order-save-button top-button"
              color="#2D9CDB"
              @click="callUpdateOrder"
            >
              <div class="button-inner">
                <span>保存</span>
              </div>
            </vs-button>
          </div>
          <div class="table-area">
            <div class="header row">
              <div
                class="cell index"
              >表示順
              </div>
              <div
                class="cell index"
              >項目名
              </div>
            </div>
            <draggable
              v-model="data"
              @start="drag=true"
              @end="drag=false"
              v-bind="dragOptions"
            >
              <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                <div class="row ordered"
                  :class="{
                    'focused': isEditingId == rowData.id,
                    'dragged': drag,
                  }"
                  v-for="(rowData, index) in data"
                  :key="index">
                  <div class="index cell order-number">
                    {{index + 1}}
                  </div>
                  <div class="cell column-name">
                    {{rowData.label || rowData.name}}
                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import draggable from 'vuedraggable'
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");
const { mapState: mapStateOfPortMaster } = createNamespacedHelpers("portMaster");


export default {
  components: {
    draggable,
  },
  data() {
    return {
      drag: false,
      isEditingId: "",
      data: []
    };
  },
  async created() {
    await this.fetchColumnsFromFirestore(this.selectedPort)
    this.data = this.destinationWorkHeaders

  },
  computed: {
    ...mapState({
      destinationWorkHeaders: state => state.destinationWorkHeaders,
    }),
    ...mapStateOfPortMaster({
      selectedPort: state => state.selectedPort,
    }),    
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    },
    
  },
  methods: {
    ...mapActions([
      "fetchColumnsFromFirestore", "updateColumnOrder"
    ]),
    async callUpdateOrder() {
      try {
        let sortOrders = this.data.map((rowData, index) => {
          return {
            columnKey: rowData.columnKey,
            sort_order: index + 1,
          }
        })
        await this.updateColumnOrder({enterprisePort:this.selectedPort, sortOrders: sortOrders})
        this.$vs.notify({
          title: "表示順序を更新しました。",
          color: "success",
          iconPack: "feather",
          icon: "icon-check"
        })
        this.$router.push(
          {
            name: "addon-port-master-destination-work-edit"
          }
        )
      } catch(e) {
        this.$vs.loading.close()
        this.$vs.notify({
          title: "表示順序を更新できませんでした。",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        })
        this.$router.push(
          {
            name: "addon-port-master-destination-work-edit"
          }
        )
      }
    },
    
    cancelEditOrder() {
      this.$router.push(
        {
          name: "addon-port-master-destination-work-edit"
        }
      )
    },
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
#edit-column-order {
  min-width: 940px;
  .order-number {
    width: 40px;
  }
  .column-name {
    width: 200px;
  }
  .flip-list-move {
    transition: transform 0.5s;
  }
  .no-move {
    transition: transform 0s;
  }
  .ghost {
    opacity: 0.5;
    background: $pm-super-light-blue;
  }

  .title {
    font-size: 18px;
  }
  .upper-controller {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
  }
  .add-button, .order-cancel-button {
    margin-left: auto;
    margin-right: 20px;
  }
  .top-button {
    height: 42px;
  }
  .button-inner {
    display: flex;
    align-items: center;
  }
  .header {
    font-weight: bold;
  }
  .row {
    min-height: 49px;
    height: fit-content;
    display: flex;
    border-bottom: solid 1px $pm-light-white;
  }
  .cell {
    display: flex;
    margin-right: 20px;
    padding: 5px 10px;
    align-items: center;
    &.name {
      width: 170px;
    }
    &.index {
      font-weight: bold;
      width: 70px;
      margin-right: 10px;
    }
  }
  
  .row.focused {
    background: $pm-white;
  }
  .row.ordered:hover {
    background: $pm-white;
    cursor: grab;
  }
  .row.dragged:hover {
    cursor: move;
  }
  .control-button {
    margin-right: 10px;
  }
}

</style>
